export const pos = {
  "header": {
    "title": "เชื่อมกัญ | จุดบริการ",
    "switchUser": "เปลี่ยนผู้ใช้",
    "customerPortal": "พอร์ทัลลูกค้า",
    "previewPortal": "ดูตัวอย่างพอร์ทัล",
    "shiftOpen": "กะ: เปิดอยู่",
    "clockIn": "เข้างาน"
  },
  "logoutConfirm": {
    "title": "ยืนยันการเปลี่ยนผู้ใช้",
    "message": "คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบและกลับไปที่หน้าจอ PIN?",
    "confirmButton": "ใช่, เปลี่ยนผู้ใช้"
  },
  "aiOrder": {
    "title": "เพิ่มรายการอัจฉริยะ",
    "description": "พิมพ์รายการเช่น \"สยามสติว่า 2 และกัมมี่ 1\" แล้วให้ AI เพิ่มลงในตั๋ว",
    "placeholder": "ตัวอย่าง: บางกอกคุช 1, บราวนี่ 2, และไปป์ 1",
    "addButton": "เพิ่มลงในออเดอร์",
    "parsingButton": "กำลังประมวลผล...",
    "disabled": "คุณสมบัตินี้ถูกปิดใช้งานอยู่",
    "disabledHint": "โปรดเพิ่ม Gemini API key ของคุณในไฟล์ src/firebase.config.ts เพื่อเปิดใช้งาน",
    "proFeature": "คุณสมบัติสำหรับ Pro",
    "proFeatureHint": "กรุณาอัปเกรดเป็นแผน Pro เพื่อเปิดใช้งานการสั่งซื้อด้วย AI",
    "upgradeButton": "อัปเกรดแผน"
  },
  "tickets": {
    "title": "บิลที่พักไว้",
    "new": "เปิดบิลใหม่",
    "items": "{{count}} รายการ",
    "total": "รวม:",
    "empty": "ไม่มีบิลที่พักไว้"
  },
  "grid": {
    "outOfStock": "สินค้าหมด",
    "empty": "ไม่พบสินค้าในหมวดหมู่นี้"
  },
  "ticket": {
    "emptyCart": "ไม่สามารถชำระเงินสำหรับรถเข็นที่ว่างเปล่าได้",
    "customerLabel": "ผู้ป่วย (Patient)",
    "addCustomerTitle": "ลงทะเบียนผู้ป่วยใหม่",
    "customerPlaceholder": "ค้นหาจากชื่อ, เบอร์โทร, หรือรหัส...",
    "customerError": "เกิดข้อผิดพลาดในการโหลดข้อมูล",
    "customerErrorDetails": "เกิดข้อผิดพลาดในการโหลดข้อมูล ตรวจสอบคอนโซลสำหรับรายละเอียด",
    "customerEmptySystem": "ไม่พบข้อมูลในระบบ",
    "customerEmptySearch": "ไม่พบข้อมูลสำหรับ \"{{term}}\"",
    "noTicketSelected": "ยังไม่ได้เลือกบิล",
    "ticketNumber": "บิล #{{id}}",
    "clearButton": "ล้าง",
    "cartEmpty": "ไม่มีสินค้าในตะกร้า",
    "cartEmptyHint": "เพิ่มสินค้าจากรายการ",
    "selectTicket": "เลือกบิล",
    "selectTicketHint": "หรือสร้างบิลใหม่",
    "taxToggleEnable": "เปิดใช้งานภาษี",
    "taxToggleDisable": "ปิดใช้งานภาษี",
    "prescriptionStatus": "สถานะใบสั่งยา",
    "requestPrescription": "ขอใบสั่งยา",
    "requestPrescriptionTooltip": "กรุณาเลือกผู้ป่วยก่อนทำการขอใบสั่งยา",
    "prescriptionPending": "กำลังรอแพทย์อนุมัติ...",
    "prescriptionApproved": "อนุมัติแล้ว! สามารถชำระเงินได้",
    "prescriptionRejected": "คำขอถูกปฏิเสธ กรุณาลบรายการออก",
    "prescriptionQuota": "โควต้าใบสั่งยา",
    "quotaRemaining": "คงเหลือ",
    "quotaExpires": "หมดอายุ",
    "chargeButton": "ชำระเงิน",
    "paymentTitle": "การชำระเงิน",
    "paymentCash": "เงินสด",
    "paymentQr": "คิวอาร์โค้ด"
  },
  "scan": {
    "assignSuccess": "เลือกผู้ป่วย: {{name}}",
    "cardNotFound": "ไม่พบรหัสบัตร: {{uid}}",
    "noTicket": "กรุณาเลือกบิลก่อนสแกนบัตร",
    "assignError": "ไม่สามารถเลือกผู้ป่วยได้: {{error}}",
    "genericError": "เกิดข้อผิดพลาดในการค้นหา: {{error}}"
  },
  "kiosk": {
    "title": "จุดลงทะเบียนเชื่อมกัญ",
    "subtitle": "Patient Intake Kiosk",
    "restoring": "กำลังกู้คืนข้อมูลเดิม...",
    "steps": {
        "step1": "1. ยืนยันตัวตน (เสียบบัตร / ถ่ายรูปบัตร / กรอกเอง)",
        "step2": "2. ระบุอาการเบื้องต้นเพื่อคัดกรอง",
        "step3": "3. พบแพทย์ (ผ่านวิดีโอคอล หรือ ห้องตรวจ)",
        "step4": "4. รับใบรับรองแพทย์ เพื่อนำไปซื้อยาที่ร้านค้า"
    },
    "welcome": {
        "btn": "ลงทะเบียนรับคำปรึกษา",
        "subtitle": "Register for Consultation"
    },
    "kyc": {
        "title": "ข้อมูลผู้ป่วย",
        "stepLabel": "ขั้นตอน 1/4",
        "selectMethod": "เลือกวิธีการนำเข้าข้อมูล",
        "methodCard": "เครื่องอ่านบัตร",
        "methodCardDesc": "เสียบบัตร / Bluetooth Reader",
        "methodOcr": "ถ่ายรูปบัตร (AI)",
        "methodOcrDesc": "สแกนบัตรด้วยกล้อง",
        "methodManual": "กรอกข้อมูลเอง",
        "methodManualDesc": "พิมพ์ด้วยตนเอง",
        "statusWaiting": "กำลังรอข้อมูลจากบัตร...",
        "statusReading": "กำลังอ่านข้อมูลจากชิป...",
        "statusConnected": "เชื่อมต่อเครื่องอ่านสำเร็จ",
        "statusSimulating": "ไม่พบอุปกรณ์ กำลังใช้ระบบจำลอง (Simulation)...",
        "statusOcr": "AI กำลังอ่านข้อมูลหน้าบัตร...",
        "statusSim": "โหมดจำลอง (Simulation)",
        "next": "ถัดไป",
        "back": "ย้อนกลับ"
    },
    "photo": {
        "title": "ยืนยันใบหน้า (Face Match)",
        "stepLabel": "ขั้นตอน 2/4",
        "instruction": "ถ่ายภาพหน้าตรงของผู้ป่วย",
        "retake": "ถ่ายใหม่",
        "confirm": "ใช้รูปนี้",
        "skip": "ข้าม (กรณีมีรูปในระบบแล้ว)"
    },
    "symptoms": {
        "title": "คัดกรองอาการเบื้องต้น",
        "stepLabel": "ขั้นตอน 3/4",
        "question": "ผู้ป่วยมีอาการเหล่านี้หรือไม่? (เลือกได้มากกว่า 1 ข้อ)",
        "other": "ระบุอาการอื่นๆ:",
        "otherPlaceholder": "โปรดระบุอาการเพิ่มเติม...",
        "consent": "ข้าพเจ้ายินยอมให้เปิดเผยข้อมูลสุขภาพและภาพถ่ายแก่คลินิกเพื่อการวินิจฉัยและออกใบรับรองแพทย์ (PDPA Consent)",
        "confirm": "ยืนยัน & เข้าคิวตรวจ",
        "processing": "กำลังบันทึก..."
    },
    "waiting": {
        "status": "กำลังเชื่อมต่อกับแพทย์ (Waiting for Connection)",
        "title": "เข้าคิวตรวจเรียบร้อย",
        "message": "รอแพทย์ตอบรับ...",
        "joinCall": "เข้าร่วมวิดีโอคอล (Join Call)",
        "cancel": "ยกเลิกคิว / ลงทะเบียนคนใหม่"
    },
    "completed": {
        "title": "ใบรับรองแพทย์อนุมัติแล้ว",
        "subtitle": "Medical Certificate Issued",
        "instruction": "กรุณานำใบรับรองนี้ไปยื่นที่ร้านขายยา",
        "certId": "Certificate ID",
        "approvedBy": "อนุมัติโดย Dr.",
        "saveImage": "บันทึกภาพลงมือถือ",
        "print": "พิมพ์กระดาษ",
        "finish": "เสร็จสิ้น / กลับหน้าหลัก"
    }
  },
  "sidebar": {
    "sales": "ยอดขาย",
    "receipts": "ใบเสร็จ",
    "shift": "กะ",
    "settings": "การตั้งค่า",
    "backOffice": "ระบบหลังร้าน"
  },
  "settingsModal": {
    "title": "การตั้งค่า POS",
    "tabs": {
      "general": "ทั่วไป",
      "printer": "เครื่องพิมพ์",
      "tax": "ภาษี"
    },
    "general": {
      "title": "การตั้งค่าทั่วไป",
      "description": "ตั้งค่าสำหรับเครื่อง POS นี้โดยเฉพาะ (บันทึกในเครื่องนี้เท่านั้น)",
      "cameraScan": {
        "title": "เปิดใช้งานการสแกนบาร์โค้ดด้วยกล้อง",
        "description": "ใช้กล้องของอุปกรณ์เพื่อสแกนบาร์โค้ดสินค้า"
      },
      "darkMode": {
        "title": "โหมดกลางคืน (Dark Mode)",
        "description": "หน้าจอ POS ถูกออกแบบมาสำหรับโหมดกลางคืน"
      }
    },
    "printer": {
      "title": "เลือกเครื่องพิมพ์",
      "description": "เลือกอุปกรณ์ POS ที่คุณกำลังใช้งานเพื่อตั้งค่าเครื่องพิมพ์",
      "empty": "ไม่พบอุปกรณ์ POS กรุณาเพิ่มอุปกรณ์ในระบบหลังร้าน",
      "back": "กลับไปที่รายการอุปกรณ์",
      "titleEdit": "ตั้งค่าเครื่องพิมพ์สำหรับ {{deviceName}}"
    },
    "tax": {
      "title": "การตั้งค่าภาษี",
      "description": "การตั้งค่านี้จะถูกใช้ร่วมกันทุกเครื่อง POS ในร้านค้า",
      "enable": "เปิดใช้งานระบบภาษี",
      "taxName": "ชื่อภาษี (เช่น VAT)",
      "taxRate": "อัตราภาษี (%)"
    }
  }
};